import axios from 'axios';
import firebase from 'firebase/app';



export const regenInterests = async(content, setInterests, id, fbProfile, setIntLoad, auth, docId, profile) =>{
    const message= { Input: content };
    setIntLoad(true)
         
        axios
        .post('https://boundapiv2.herokuapp.com/LIinterests', message)
        .then((response) => {

            let arr = response.data.split("\n")
            let sendArr = []
            for(let i = 0; i < arr.length; i++){
                let int = arr[i].substring(3)
                if (int !== 'null' && int !== "" && int !== 'null ' && int !== ' null'){
                    sendArr.push(int)
                }
            }

            setInterests(sendArr)
            setIntLoad(false)
            updateSavedInt(fbProfile, sendArr, auth)
            changeInteresInLastSearchContact(fbProfile,auth, docId, sendArr)
            
            firebase
            .firestore()
            .collection('organizations')
            .doc(fbProfile.company)
            .collection('prospects')
            .doc(id)
            .update({
                ProspectInterest: sendArr,
                RefreshedInterest: 'yes'
            }).then(()=>{
                // setIntLoad(false)
                // updateSavedInt(fbProfile, sendArr, auth)
            })
        

            // if(sendArr?.length > 0){
            //     //setInterests(sendArr)
            //     checkExpDate(profile, sendArr, setInterests)
            // }



            // var function1 = () =>{    
            //     var index = 0
    
            //     var checkedArr = []
    
            //     //  this is the for loop we need to wait for before moving to other function
            //     function getArray(){
                 
            //         if (index < sendArr.length){
            //             let data = { Input: sendArr[index] }
            //             axios.post('https://boundapiv2.herokuapp.com/getIntClassified', data, {
            //                 headers: {
            //                 'Access-Control-Allow-Origin': '*',
            //                 'Content-Type': 'application/json'
            //                 }
            //             })
            //             .then((res) =>{
            //                 if(res.data === "Hobby"){
            //                     // console.log(res.data)
            //                     // console.log(sendArr[index])
            //                     checkedArr.push(sendArr[index])
            //                     index = index + 1
            //                     getArray()
            //                 } else {
            //                     index = index + 1
            //                     getArray()
            //                 }
            //             }, (error) => {
            //                 setInterests(sendArr)
            //                 setIntLoad(false)
            //                 updateSavedInt(fbProfile, sendArr, auth)
            //                 changeInteresInLastSearchContact(fbProfile,auth, docId, sendArr)
            //                 console.log(error)
            //             })
            //         } else {
            //             setInterests(checkedArr)
            //             setIntLoad(false)
            //             updateSavedInt(fbProfile, checkedArr, auth)
            //             changeInteresInLastSearchContact(fbProfile,auth, docId, checkedArr)
                        
            //             firebase
            //             .firestore()
            //             .collection('organizations')
            //             .doc(fbProfile.company)
            //             .collection('prospects')
            //             .doc(id)
            //             .update({
            //                 ProspectInterest: checkedArr,
            //                 RefreshedInterest: 'yes'
            //             }).then(()=>{
            //                 // setIntLoad(false)
            //                 // updateSavedInt(fbProfile, sendArr, auth)
            //             })
            //         }
    
            //     } 
            //     getArray()
            // }
    
            // getting function
            // function1()

        }, (error) => {
        console.log(error);
        });
    } 

const changeInteresInLastSearchContact = (fbProfile, auth, docId, checkedArr) => {
    firebase
        .firestore()
        .collection('organizations')
        .doc(fbProfile.company)
        .collection('searchedContactLastFive')
        .doc(auth.uid)
        .collection('searchedContact')
        .doc(docId)
        .update({
            contactInterest: checkedArr
        })
}

const updateSavedInt = (fbProfile, checkedArr, auth) => {
 
    firebase
        .firestore()
        .collection('organizations')
        .doc(fbProfile.company)
        .collection('searchedContact')
        .doc(auth.uid)
        .update({
            contactInterest: checkedArr,
        })
}

// function checkExpDate(contact, sendArr, setInterests){
//     if(contact?.experiences?.length > 0){
//         var dateToday = new Date();
//         var startDate = new Date(contact?.experiences[0]?.starts_at?.year, (contact?.experiences[0]?.starts_at?.month - 1), contact?.experiences[0]?.starts_at?.day)
//         const diffTime = Math.abs(dateToday - startDate);
//         const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
        
//         if(diffDays <= 60){
//             var arrInt = sendArr
//             var arrAdd =['Just started a new role']
//             setInterests(arrInt.concat(arrAdd).reverse())
//         }else{
//             setInterests(sendArr)
//         }
//     }else{
//         setInterests(sendArr)
//     }
// }